export default __webpack_public_path__ + "static/media/success.d644c682.svg";